// extracted by mini-css-extract-plugin
module.exports =  {"title":"k620TyLo"};